// MUI
import { Box } from '@mui/material';
import FileUpload from 'components/FileUpload';

const FileUploadItem = ({ value }) => {
  return (
    <Box
      sx={{
        fontWeight: 500,
        fontSize: '13px',
        color: '#fff',
        letterSpacing: '0.15px',
      }}
    >
      <FileUpload
        onChangeCb={() => console.log('')}
        attachments={value}
        isPreview={true}
      />
    </Box>
  );
};

export default FileUploadItem;
